/* eslint-disable max-len */
export const environment = {
    production: false,
    debug     : true,
    api       : {
        graphql: 'https://dev-pvt.azurewebsites.net/graphql',
        rest   : 'https://dev-pvt.azurewebsites.net',
    },
    clientId   : '67b40710-9c1c-45e9-a286-ff7ec44a10c6',
    scope      : 'api://e72be9b2-2c26-4d20-b75b-414867554773/access_as_user',
    authority  : 'https://login.microsoftonline.com/b6fbec92-ea74-4b61-a8a5-0ca5e669dca2',
    redirectUri: 'https://valuationengine.hipdataanalytics.com',
    powerbi    : {
        group     : '4a08734a-c680-4122-b721-06d6b8a0bf93',
        dataset   : '6a6f6018-ed55-4852-ac69-a571bc348764',
        reportLink: 'https://app.powerbi.com/reportEmbed?reportId=f5b4a8fe-7acb-4159-adef-2a56926e010b&autoAuth=true&ctid=b6fbec92-ea74-4b61-a8a5-0ca5e669dca2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtZXVyb3BlLWItcHJpbWFyeS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D',
    },
    lang: {
        base    : 'es',
        fallback: 'es',
        langs   : ['es', 'en'],
    },
};
